export class SectorModel {

  id: number;
  nombre: string;

  constructor() {
    this.nombre = '';
  }
}
